/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import auth from '@/auth/service.js';

let state = {};

state[auth.tokenKey()] = null;
state[auth.tokenExpiryKey()] = null;
state[auth.userInfoKey()] = {};
state.isInitialized = false;

export default state;
